import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import process from 'process';
import { Buffer } from 'buffer';
import './index.css';
import './i18n';
import App from './App';
import store from './redux/store';

window.process = process;
window.Buffer = Buffer;

// THE BUILD BANNER HAS TO BE THE BUILD.
//
// This was the literal string "#191", so every deployment since has announced
// itself as #191 in the console. QA reads it to fill in the "Build:" field on
// the test report, so a retest of a fixed build was signed off as #191 — the
// pre-fix build — and reconciling what had actually been tested against what
// had shipped cost real time on 2026-09-23.
//
// REACT_APP_GIT_COMMIT is injected at build time when the pipeline sets it;
// falling back to "dev" is honest about not knowing, which "#191" was not.
const BUILD_ID = process.env.REACT_APP_GIT_COMMIT || process.env.REACT_APP_BUILD_ID || 'dev';
console.log(`%c REGURE BUILD: ${BUILD_ID} `, 'background:#800020;color:#fff;font-size:14px;padding:4px 8px;border-radius:4px;');

ReactDOM.render(
  <Provider store={store}>
    {/* <VideoState> */}
    <App />
    {/* </VideoState> */}
  </Provider>,
  document.getElementById('root'),
);
